import { useMutation } from '@tanstack/react-query'
import type { ReturnsApiProcessRequest } from '@itsrever/returns-api-types'
import { returnsApi } from '@/redux/api/returns-api-slice'

const createProccess = async ({
  ecommerceID,
  processData
}: ReturnsApiProcessRequest) => {
  const { data } = await returnsApi.process({
    ecommerceID,
    processData
  })

  return data
}

export const useProcess = () => {
  return useMutation({
    mutationFn: createProccess
  })
}
